var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"model-17"},[_c('div',{staticClass:"video",style:({backgroundColor:_vm.editablePageConfig.editable_page_config_content.back_color})},[_c('video',{attrs:{"src":_vm.editablePageConfig.editable_page_config_content.video,"controls":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }